module.exports = __webpack_public_path__ + "media/images/pokerroom/partypoker/step2-pict02-full-fde8f9e250aae228a5befcff7afb80a5.jpg";